import { message } from "antd";
import { Sessao } from "../../../../helpers/Token";
import iconRecuperacaoPrevidenciaria from "../../../../assets/icons/icon-recuperacao-previdenciaria.svg";
import iconPisCofinsDiesel from "../../../../assets/icons/icon-pis-cofins-diesel.svg";
import iconIrPensaoAlimenticia from "../../../../assets/icons/icon-ir-pensao-alimenticia.svg";
import store from "../../../../store/configureStore";
import {
  setOpenModalPlanilhaDiesel,
  setOpenModalPlanilhaIrPensaoAlimenticia,
} from "../../../../store/actions/planilhas";
import {
  setOpenModalVerbasComunicado,
  setOpenModalRevisor,
  setOpenModalRevisorBloqueio,
  setOpenModalTerceirosInformativo,
  setOpenModalTerceirosVideo
} from "../../../../store/actions/termos";
import { setOpenModalSubvencoes } from "../../../../store/actions/subvencoes";

const urlImage = "https://images.e-auditoria.com.br/erecuperador/bemvindo";
// REC-217 - Validando usuário de teste
const isUsuarioTeste = () => {
  const planoTeste = Sessao("planoTeste");

  return planoTeste;
};

// VER132 - Termo Aceite Verbas
const termoAceitoVerbas = () => {
  const termoAceitoVerbas = sessionStorage.getItem("termoAceitoVerbas");

  return termoAceitoVerbas;
};

function isPlanoProfissionalLiberal() {
  const planoProfissionalLiberal = Sessao('planoProfissionalLiberal');
  if (planoProfissionalLiberal === true) return true;
  return false;
}

function isPlanoMeuPrimeiroClienteCompleto() {
  const planoMeuPrimeiroClienteCompleto = Sessao('planoMeuPrimeiroClienteCompleto');
  if (planoMeuPrimeiroClienteCompleto === true) return true;
  return false;
}

const onClickTerceiros = () => {
  const video = localStorage.getItem("naoExibirVideoTerceiros");
  const info = localStorage.getItem("naoExibirTerceirosInformativo");

  if (video && info)
    window.location = process.env.REACT_APP_CONTRIBUICOES_TERCEIROS_URL;

  if (!video) {
    store.dispatch(setOpenModalTerceirosVideo(true));
  }

  if (!info) {
    store.dispatch(setOpenModalTerceirosInformativo(true));
  }
};

export const simplesNacional = {
  label: "simplesNacional",
  modulos: [
    {
      title: "recuperação de pis/cofins para empresas do simples nacional",
      description:
        "Realize o levantamento de valores indevidamente recolhidos pela não segregação das receitas decorrentes da venda de produtos sujeitos à tributação Monofásica ou à Substituição Tributária do PIS/Pasep e da COFINS.",
      icon: `${urlImage}/simples-nacional/recuperacao.svg`,
      beta: false,
      onClick: () => {
        window.location = "/recuperacao";
      },
    },
    {
      title:
        "segregação de receitas para empresas do simples nacional - pis/cofins e icms",
      description:
        "Realize segregação das Receitas decorrentes da venda de produtos sujeitos à tributação Monofásica do PIS/Pasep e da COFINS ou à Substituição Tributária do ICMS.",
      icon: `${urlImage}/simples-nacional/segregacao.svg`,
      beta: false,
      onClick: () => {
        sessionStorage.setItem("icmsModule", true);
        window.location = "/recuperacao";
      },
    },
    // {
    //   title: "pis/cofins ST sobre cigarros",
    //   description: "Calcule o crédito de PIS/COFINS ST sobre cigarros.",
    //   icon: `${urlImage}/lucro-real/icon_calculador_cigarros.svg`,
    //   beta: false,
    //   onClick: () => {
    //     window.location = process.env.REACT_APP_ST_CIGARROS_URL;
    //   },
    // },
  ],
};

export const lucroRealPresumido = {
  label: "lucroRealPresumido",
  modulos: [
    {
      title: "exclusão do icms da base de cálculo do pis/cofins",
      description:
        "Calcule o crédito resultante da exclusão do ICMS da base de cálculo do PIS e da COFINS.",
      icon: `${urlImage}/lucro-real/icms.svg`,
      beta: false,
      onClick: () => {
        window.location = process.env.REACT_APP_EXCLUSAO_ICMS_URL;
      },
    },
    {
      title: "exclusão do issqn da base de cálculo do pis/cofins",
      description:
        "Calcule o crédito resultante da exclusão do ISSQN da base de cálculo do PIS e da COFINS.",
      icon: `${urlImage}/lucro-real/issqn.svg`,
      beta: false,
      onClick: () => {
        window.location = process.env.REACT_APP_EXCLUSAO_ISS_URL;
      },
    },
    {
      title: "subvenções de icms",
      description:
        "Apure o valor auferido com receitas de subvenções de investimento.",
      icon: `${urlImage}/lucro-real/subvencoes.svg`,
      beta: false,
      onClick: () => {
        if (localStorage.getItem("naoExibirSubvencoesComunicado")) {
          window.location = process.env.REACT_APP_SUBVENCOES_URL;
        } else {
          store.dispatch(setOpenModalSubvencoes(true));
        }
      },
    },
    {
      title: "revisor pis/cofins",
      description:
        "Faça a revisão do cadastro de produtos e da tributação de PIS/COFINS aplicada sobre as operações de saída.",
      icon: `${urlImage}/lucro-real/revisorpiscofins.svg`,
      beta: false,
      onClick: () => {
        if (!isPlanoProfissionalLiberal() && !isPlanoMeuPrimeiroClienteCompleto()) {
          if (localStorage.getItem("naoExibirVideoRevisor")) {
            window.location = process.env.REACT_APP_REVISOR_URL;
          } else {
            store.dispatch(setOpenModalRevisor(true));
          }
        } else {
          store.dispatch(setOpenModalRevisorBloqueio(true));
        }
      },
    },
    {
      title: "inss sobre verbas indenizatórias",
      description:
        "Calcule o crédito resultante do recolhimento indevido de CPP sobre as verbas indenizatórias.",
      icon: `${urlImage}/lucro-real/inss.svg`,
      beta: false,
      onClick: () => {
        if (termoAceitoVerbas()) {
          // VER-132 - Validando termo aceite
          window.location = process.env.REACT_APP_VERBAS_INSS_URL;
        } else {
          store.dispatch(setOpenModalVerbasComunicado(true));
        }
      },
    },
    {
      title: "contribuições para terceiros",
      description:
        "Calcule o crédito resultante da limitação da base de cálculo das Contribuições para Terceiros em 20 salários mínimos.",
      icon: `${urlImage}/lucro-real/contribuicoes.svg`,
      beta: false,
      onClick: () => onClickTerceiros(),
    },
    // {
    //   title: "pis/cofins ST sobre cigarros",
    //   description: "Calcule o crédito de PIS/COFINS ST sobre cigarros.",
    //   icon: `${urlImage}/lucro-real/icon_calculador_cigarros.svg`,
    //   beta: false,
    //   onClick: () => {
    //     window.location = process.env.REACT_APP_ST_CIGARROS_URL;
    //   },
    // },
  ],
};

export const gerenciadorPropostas = {
  label: "gerenciadorPropostas",
  modulos: [
    {
      title: "gerenciador de propostas e contratos",
      description:
        "Gerencie propostas e contratos gerados nos processos de recuperação de créditos.",
      icon: `${urlImage}/gerenciador/propostas.svg`,
      beta: false,
      onClick: () => {
        if (!isUsuarioTeste()) {
          // REC-217 - Validando usuário de teste
          window.location = process.env.REACT_APP_GESTAO_CONTRATOS_URL;
        } else {
          message.error("Módulo não disponível para contas de teste");
        }
      },
    },
  ],
};

export const arquivado = {
  label: "arquivado",
  modulos: [
    {
      title: "RECUPERAÇÃO DO DIFAL PARA EMPRESAS DO SIMPLES NACIONAL",
      description:
        "Calcule o crédito resultante do recolhimento indevido do DIFAL por empresas do Simples Nacional.",
      icon: `${urlImage}/lucro-real/difalsimples.svg`,
      beta: true,
      onClick: () => {
        window.location = process.env.REACT_APP_DIFAL_SIMPLES_URL;
      },
    },
    {
      title: "Exclusão do ICMS do PIS/COFINS (utilizando somente as EFD's)",
      description:
        "Calcule o crédito resultante da exclusão do ICMS da base de cálculo do PIS e da COFINS.",
      icon: `${urlImage}/lucro-real/icms.svg`,
      beta: false,
      onClick: () => {
        window.location = process.env.REACT_APP_EXCLUSAO_ICMS_ARQUIVADO_URL;
      },
    },
  ],
};

export const eMultiplicador = {
  label: "eMultiplicador",
  modulos: [
    {
      title: "e-Multiplicador",
      description:
        "Crie e comercialize seu próprio sistema de segregação das receitas para empresas do Simples Nacional.",
      icon: `${urlImage}/multiplicador/e-mult-icon-rec.svg`,
      beta: true,
      onClick: () => {
        window.location = process.env.REACT_APP_MULTIPLICADOR_URL;
      },
    },
  ],
};

export const pessoasFisicas = {
  label: "pessoaFisica",
  modulos: [
    {
      title: "Recuperação Previdenciária Acima do Teto de Contribuição",
      description:
        "Calcule o crédito de INSS recolhido acima do teto de Contribuição.",
      icon: iconRecuperacaoPrevidenciaria,
      beta: false,
      onClick: () => {
        window.location = process.env.REACT_APP_RECUPERADOR_INSS_URL;
      },
    },
  ],
};

export const planilhasCalculo = {
  label: "planilhasCalculo",
  modulos: [
    {
      title: "PIS/COFINS sobre Diesel - MP 1118/22",
      description:
        "Calcule o crédito de PIS/COFINS sobre a aquisição de Diesel, GLP e Querosene de Aviação, no período de 11 de março a 15 de agosto de 2022, levando em consideração o prazo de noventa dias contados da publicação da Medida Provisória nº 1.118 de 2022.",
      icon: iconPisCofinsDiesel,
      beta: false,
      planilha: true,
      onClick: () => {
        store.dispatch(setOpenModalPlanilhaDiesel(true));
      },
    },
    {
      title: "IR sobre pensão alimentícia - ADI 5422",
      description:
        "Calcule o crédito de Imposto de Renda sobre os valores recebidos de Pensão Alimentícia, conforme julgamento da Ação Direta de Inconstitucionalidade (ADI) nº 5422 pelo Supremo Tribunal Federal.",
      icon: iconIrPensaoAlimenticia,
      beta: false,
      planilha: true,
      onClick: () => {
        store.dispatch(setOpenModalPlanilhaIrPensaoAlimenticia(true));
      },
    },
  ],
};
